import AuthValidation from "../../validation/AuthValidation";
import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";

export class DeleteServerRequest implements IRequestModel {

    constructor(serverId: string) {
        this.server_id = serverId;
    }

    uri: string = "server/list";
    method: HttpMethod = HttpMethod.DELETE;

    server_id: string;

    isValid(): ValidationResponse {
        return ValidationResponse.Success();
    }
}